<template>
  <div class="container">
    <template v-for="category in table['categories']">
      <div
        :key="category"
        v-if="!((category == 'vc' && !vc) || (category == 'cvc' && !cvc))"
      >
        <h2>{{ category }}</h2>

        <TableComponentNumber
          @select="$listeners['select']"
          v-if="category == 'number'"
          :cuneiform-class="cuneiformClass"
          :transliteral-style="transliteralStyle"
        />
        <TableComponent
          @select="$listeners['select']"
          :category="category"
          :level="depth"
          :cuneiform-class="cuneiformClass"
          :transliteral-style="transliteralStyle"
          v-else
        />
      </div>
    </template>
  </div>
</template>

<script>
const signtable = require("@/data/syllables_table.json");
import TableComponent from "./SyllablesTableComponent.vue";
import TableComponentNumber from "./SyllablesTableNumber.vue";
export default {
  data() {
    return {};
  },
  props: {
    level: {
      type: Number,
      default: 0
    },
    cuneiformClass: {
      type: String,
      default: "akkadian"
    },
    transliteralStyle: String
  },
  components: {
    TableComponent,
    TableComponentNumber
  },
  computed: {
    table() {
      return signtable;
    },
    vc() {
      return this.level >= 1;
    },
    cvc() {
      return this.level >= 1;
    },
    depth() {
      return {
        "0": 0,
        "1": 0,
        "2": 2,
        "3": 2
      }[this.level];
    }
  }
};
</script>

<style lang="scss">
div.syllables__tab {
  margin-bottom: 0.5em !important;
}
.syllables__tabitem {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom-color: #dbdbdb;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  color: #4a4a4a;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: -1px;
  padding: 0.5em 1em;
  vertical-align: top;
}
.tabs li.is-active span {
  border-bottom-color: #3273dc;
  color: #3273dc;
}

.tabs ul {
  flex-shrink: 1;
  flex-wrap: wrap;
}
</style>
